import { ref, computed, reactive } from '@vue/composition-api'

export default function useFilterHeaderTable() {
  const entities = ref('')

  let searchTimeout = null

  const searchValue = reactive({
    query: '',
  })

  const filters = ref([])

  const contentFilter = reactive({ search: null, filterColumns: [] })

  const ordering = ref([])

  const onSelectEntities = input => {
    entities.value = input
  }

  const onSetValueSearch = searchInput => {
    searchValue.query = searchInput
    onSearch()
  }

  const onSearch = (key, timeout = 500) => {
    if (searchTimeout) {
      clearTimeout(searchTimeout)
    }

    searchTimeout = setTimeout(() => {
      buildFilterPayload(key)
    }, timeout)
  }

  const sortingChanged = sort => {
    const order = []
    const { sortBy } = sort
    const { sortDesc } = sort
    if (sortBy) {
      sortDesc
        ? order.push({ Seq: 1, Key: sortBy, Direction: 'DESC' })
        : order.push({ Seq: 1, Key: sortBy, Direction: 'ASC' })
      return (ordering.value = order)
    }
    return (ordering.value = [])
  }

  const buildFilterPayload = key => {
    contentFilter.search = {
      Seq: 1,
      Key: !key ? 'query' : key,
      Value: searchValue.query,
    }

    onFilter()
  }

  const onSelectFilter = (key, option) => {
    if (typeof option !== 'number' && !option) {
      contentFilter.filterColumns = contentFilter.filterColumns.filter(
        column => column.key !== key,
      )
      return onFilter()
    }

    const filterIndex = contentFilter.filterColumns.findIndex(
      column => column.key == key,
    )

    if (filterIndex >= 0) {
      contentFilter.filterColumns[filterIndex].value = checkOptionValue(option)
    }
    if (filterIndex < 0) {
      contentFilter.filterColumns.push({
        key,
        value: checkOptionValue(option),
      })
    }

    onFilter()
  }

  const checkOptionValue = option => (option.hasOwnProperty('value') ? option.value : option)

  const onFilter = () => {
    const filterList = []

    if (
      contentFilter.search
      && (contentFilter.search.Value
        || typeof contentFilter.search.Value === 'number')
    ) {
      filterList.push(contentFilter.search)
    }
    const lastIndex = filterList.length

    if (contentFilter.filterColumns.length > 0) {
      contentFilter.filterColumns.map((column, index) => {
        filterList.push({
          Seq: lastIndex + (index + 1),
          Key: column.key,
          Value: column.value,
        })
      })
    }

    filters.value = filterList
  }

  return {
    entities,
    filters,
    ordering,
    searchValue,
    contentFilter,
    onSelectEntities,
    onSetValueSearch,
    onSearch,
    sortingChanged,
    onSelectEntities,
    onSelectFilter,
    onFilter,
  }
}
